import { configureStore } from '@reduxjs/toolkit'
import uiReducer from './reducers/uiReducer'
import bulkPricingReducer from './reducers/bulkPricingReducer'

export default configureStore({
  reducer: {snackbar: uiReducer, bulkPricing: bulkPricingReducer}
})
